import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table,Space, message, } from 'antd';
import TechDocAdd from './TechDocAdd';
import { useBnsJiShuWenDangDelMutation, useBnsJiShuWenDangListQuery } from '../../store/ReactWebSiteApi';
import TechDocEdit from './TechDocEdit';
import ModalDel from '../../cpn/ModalDel';
import TechDocCheck from './TechDocCheck';
function TechDocList() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsJiShuWenDangListQuery({bjswd_e_id:localStorage.getItem('e_id')},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bjswd_id:key,bjswd_name,bjswd_ctime,bjswd_cname,bjswd_content,bjswd_dept_id,bjswd_dept_name,bjswd_type_name} = item;
                    return item = {key,bjswd_name,bjswd_ctime,bjswd_cname,bjswd_content,bjswd_dept_id,bjswd_dept_name,bjswd_type_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bjswd_ctime;
                    let bTimeString = b.bjswd_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'list',
            title: '标题',
            render:(_,record) => {
                return  <TechDocCheck 
                            bjswd_name={record.bjswd_name}
                            bjswd_content={record.bjswd_content}
                            bjswd_id={record.key}
                            bjswd_dept_id={record.bjswd_dept_id}
                            bjswd_dept_name={record.bjswd_dept_name}
                            bjswd_type_name={record.bjswd_type_name}
                        />
            }            
        },     
        {
            key: 'bjswd_type_name',
            title: '类型',            
            dataIndex: 'bjswd_type_name',
            
        },
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
            
        },
        {
            key: 'bjswd_dept_name',
            title: '部门',            
            dataIndex: 'bjswd_dept_name',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bjswd_ctime + record.bjswd_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <TechDocEdit
                            bjswd_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({bjswd_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />   
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsJiShuWenDangDelMutation()
    return (
        <Main t1='软件开发' t2='技术文档'>
            <Space size='large'>
                <TechDocAdd />             
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default TechDocList